<div class="leaflet-indoor">
  <div id="map"></div>
</div>
